import { graphqlOperation } from "@aws-amplify/api";
import * as queries from "../../graphql/queries";
import { makeGraphQLRequest } from "..";

const getSnapshotsByEntity = async (entityID, options = {}) => {
  return makeGraphQLRequest(
    graphqlOperation(queries.snapshotsByEntity, {
      entityID,
      sortDirection: options.sortDirection || "DESC",
      limit: options.limit || 50,
      filter: options.filter,
    })
  );
};

export default {
  getSnapshotsByEntity,
};